import { render, staticRenderFns } from "./GitbookIcon.vue?vue&type=template&id=780afae0&scoped=true"
import script from "./GitbookIcon.vue?vue&type=script&lang=js"
export * from "./GitbookIcon.vue?vue&type=script&lang=js"
import style0 from "./GitbookIcon.vue?vue&type=style&index=0&id=780afae0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780afae0",
  null
  
)

export default component.exports